/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Feed } from '../models/Feed';
import type { FeedInput } from '../models/FeedInput';
import type { MainPage } from '../models/MainPage';
import type { Material } from '../models/Material';
import type { MaterialNavigation } from '../models/MaterialNavigation';
import type { MaterialViewInput } from '../models/MaterialViewInput';
import type { MaterialViewStatus } from '../models/MaterialViewStatus';
import type { TranscriptMaterial } from '../models/TranscriptMaterial';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MaterialsService {
    /**
     * Get main page
     * @returns MainPage A list of main page
     * @throws ApiError
     */
    public static getMainPage(): CancelablePromise<MainPage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/main',
        });
    }
    /**
     * Get all courses
     * @returns any A list of courses
     * @throws ApiError
     */
    public static getCourses(): CancelablePromise<{
        items?: Array<Feed>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/courses',
        });
    }
    /**
     * Get all mashtab
     * @returns any A list of courses
     * @throws ApiError
     */
    public static getMashtab(): CancelablePromise<{
        items?: Array<Feed>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mashtab',
        });
    }
    /**
     * Get all feeds
     * @returns any A list of feeds
     * @throws ApiError
     */
    public static getFeeds(): CancelablePromise<{
        items?: Array<Feed>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/feeds',
        });
    }
    /**
     * Create a new feed
     * @param requestBody
     * @returns Feed Feed created
     * @throws ApiError
     */
    public static createFeeds(
        requestBody: FeedInput,
    ): CancelablePromise<Feed> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/feeds',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get a feed by url
     * @param urlA
     * @returns Feed Feed found
     * @throws ApiError
     */
    public static getFeedByUrl(
        urlA: string,
    ): CancelablePromise<Feed> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/feed/{url_a}',
            path: {
                'url_a': urlA,
            },
            errors: {
                404: `Feed not found`,
            },
        });
    }
    /**
     * Get a feed by ID
     * @param id
     * @returns Feed Feed found
     * @throws ApiError
     */
    public static getFeedById(
        id: string,
    ): CancelablePromise<Feed> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/feeds/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Feed not found`,
            },
        });
    }
    /**
     * Update an existing feed
     * @param id
     * @param requestBody
     * @returns Feed Feed updated
     * @throws ApiError
     */
    public static updateFeedById(
        id: string,
        requestBody: FeedInput,
    ): CancelablePromise<Feed> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/feeds/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Feed not found`,
            },
        });
    }
    /**
     * Delete a feed
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteFeedById(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/feeds/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Feed not found`,
            },
        });
    }
    /**
     * Получить список материалов
     * @param id
     * @returns any Список материалов
     * @throws ApiError
     */
    public static getMaterialsTranscript(
        id?: string,
    ): CancelablePromise<{
        items?: Array<TranscriptMaterial>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/materials/transcript',
            query: {
                'id': id,
            },
        });
    }
    /**
     * Получить список материалов
     * @param id
     * @returns any Список материалов
     * @throws ApiError
     */
    public static getMaterials(
        id?: string,
    ): CancelablePromise<{
        items?: Array<Material>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/materials',
            query: {
                'id': id,
            },
        });
    }
    /**
     * Создать материал
     * @param requestBody
     * @returns Material Материал создан
     * @throws ApiError
     */
    public static createMaterial(
        requestBody: Material,
    ): CancelablePromise<Material> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/materials',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Получить материал по идентификатору
     * @param urlA
     * @returns Material Материал найден
     * @throws ApiError
     */
    public static getMaterialByUrl(
        urlA: string,
    ): CancelablePromise<Material> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/material/{url_a}',
            path: {
                'url_a': urlA,
            },
            errors: {
                404: `Материал не найден`,
            },
        });
    }
    /**
     * Получить материал по идентификатору
     * @param id
     * @returns Material Материал найден
     * @throws ApiError
     */
    public static getMaterialById(
        id: string,
    ): CancelablePromise<Material> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/materials/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Материал не найден`,
            },
        });
    }
    /**
     * Обновить материал
     * @param id
     * @param requestBody
     * @returns Material Материал обновлён
     * @throws ApiError
     */
    public static updateMaterial(
        id: string,
        requestBody: Material,
    ): CancelablePromise<Material> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/materials/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Удалить материал
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteMaterials(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/materials/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Получить материал по идентификатору
     * @param id
     * @returns MaterialViewStatus Материал найден
     * @throws ApiError
     */
    public static getMaterialViewStatusById(
        id: string,
    ): CancelablePromise<MaterialViewStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/materials/{id}/view_status',
            path: {
                'id': id,
            },
            errors: {
                404: `Материал не найден`,
            },
        });
    }
    /**
     * Обновить материал
     * @param id
     * @param requestBody
     * @returns any Материал обновлён
     * @throws ApiError
     */
    public static updateMaterialViewStatus(
        id: string,
        requestBody: MaterialViewInput,
    ): CancelablePromise<{
        message: string;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/materials/{id}/view_status',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Получить навигацию по урокам (следующий и предыдущий урок)
     * @param url URL текущего урока
     * @returns MaterialNavigation Навигация по урокам
     * @throws ApiError
     */
    public static getMaterialNavigation(
        url: string,
    ): CancelablePromise<MaterialNavigation> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/materials/navigation',
            query: {
                'url': url,
            },
            errors: {
                404: `Урок не найден`,
            },
        });
    }
    /**
     * Отметить блок как выполненный
     * Обновляет состояние прогресса для конкретного блока материала
     * @param materialId ID материала
     * @param blockId ID блока
     * @param requestBody
     * @returns any Прогресс успешно обновлен
     * @throws ApiError
     */
    public static updateBlockProgress(
        materialId: string,
        blockId: string,
        requestBody: {
            /**
             * Статус выполнения блока
             */
            completed: boolean;
        },
    ): CancelablePromise<{
        success?: boolean;
        completed?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/progress/material/{material_id}/block/{block_id}',
            path: {
                'material_id': materialId,
                'block_id': blockId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Не авторизован`,
                404: `Материал или блок не найден`,
                500: `Внутренняя ошибка сервера`,
            },
        });
    }
    /**
     * Получить статус блока
     * Возвращает статус выполнения конкретного блока материала
     * @param materialId ID материала
     * @param blockId ID блока
     * @returns any Статус блока получен успешно
     * @throws ApiError
     */
    public static getBlockProgress(
        materialId: string,
        blockId: string,
    ): CancelablePromise<{
        /**
         * Статус выполнения блока
         */
        completed?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/progress/material/{material_id}/block/{block_id}',
            path: {
                'material_id': materialId,
                'block_id': blockId,
            },
            errors: {
                401: `Не авторизован`,
                404: `Материал или блок не найден`,
            },
        });
    }
    /**
     * Получить прогресс по всем блокам материала
     * Возвращает состояние выполнения всех блоков конкретного материала для текущего пользователя
     * @param materialId ID материала
     * @returns any Прогресс по материалу получен успешно
     * @throws ApiError
     */
    public static getMaterialProgress(
        materialId: string,
    ): CancelablePromise<{
        /**
         * Объект где ключ - ID блока, значение - статус выполнения
         */
        blocks?: Record<string, boolean>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/progress/material/{material_id}',
            path: {
                'material_id': materialId,
            },
            errors: {
                401: `Не авторизован`,
                404: `Материал не найден`,
            },
        });
    }
    /**
     * Обновить статус завершенности материала
     * Обновляет статус завершенности всего материала для текущего пользователя
     * @param materialId ID материала
     * @param requestBody
     * @returns any Статус материала успешно обновлен
     * @throws ApiError
     */
    public static updateMaterialProgress(
        materialId: string,
        requestBody: {
            /**
             * Статус завершенности материала
             */
            completed: boolean;
        },
    ): CancelablePromise<{
        success?: boolean;
        completed?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/progress/material/{material_id}',
            path: {
                'material_id': materialId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Некорректный запрос`,
                401: `Не авторизован`,
            },
        });
    }
    /**
     * Получить статус завершенности материала
     * Возвращает информацию о том, завершен ли материал текущим пользователем
     * @param materialId ID материала
     * @returns any Статус завершенности получен успешно
     * @throws ApiError
     */
    public static getMaterialCompletion(
        materialId: string,
    ): CancelablePromise<{
        /**
         * Завершен ли материал
         */
        completed?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/progress/material/{material_id}/completion',
            path: {
                'material_id': materialId,
            },
            errors: {
                401: `Не авторизован`,
                500: `Внутренняя ошибка сервера`,
            },
        });
    }
}
